namespace TabAurous {
    export interface PromoRequest extends Serenity.ListRequest {
        PromoCode?: string;
        PromoName?: string;
    }
}
